/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_FromInputs */

const en__field_from = /** @type {(inputs: _Field_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From`)
};

const de__field_from = /** @type {(inputs: _Field_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von`)
};

/**
* | output |
* | --- |
* | "From" |
*
* @param {_Field_FromInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_from = /** @type {((inputs?: _Field_FromInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_FromInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_from(inputs)
	return de__field_from(inputs)
});